module.exports = __webpack_public_path__ + "2e30f574c1cc8982bee7f8878960883c.svg";